import { QueryKey, useSuspenseQuery } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { QueryConfig } from 'lib/react-query';
import queryString from 'query-string';
import { MetricEntry } from './types';
import { prefetchData } from './prefetchData';

const getConditionsPeriods = async ({ signal }: { signal?: AbortSignal }): Promise<MetricEntry[]> => {
  const res = await apiClient.get<{ data: MetricEntry[] }>(`/conditions/periods`, {
    signal,
    paramsSerializer: (prms) => queryString.stringify(prms, { arrayFormat: 'comma' }),
  });
  return res.data.data;
};

interface UseConditionsPeriods<TData> {
  config?: QueryConfig<typeof getConditionsPeriods, TData>;
}

export const useConditionsPeriods = <TData = MetricEntry[]>({ config }: UseConditionsPeriods<TData>) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getConditionsPeriods({ signal }),
    queryKey: ['conditions', 'periods'] as QueryKey,
  });
};

export const prefetchConditionsPeriods = async () =>
  await prefetchData(getConditionsPeriods, ['conditions', 'periods'] as const);
